<template>
  <nav class="navbar topo navbar-expand-lg  navbar-light bg-light border-bottom p-0">
    <div class="container">
      <router-link
        class="navbar-brand mr-0 mr-sm-3 d-flex"
        :to="homeLink"
      >
        <span class="logo align-self-center">
          <img
            :src="logoURL"
            class="img-fluid"
            :title="'Prefeitura de Belo Horizonte -'+sigla"
            alt="Logo Prefeitura de Belo Horizonte"
          >
        </span>
        <span class="divisoria align-self-center mx-2">
          |
        </span>
        <div class="titulo">
          <span class="sigla">
            {{ sigla }}      
          </span>
          <span class="nome">
             {{ nome }}     
          </span>
        </div>
      </router-link>

      <button
        v-if="itensMenu.length"
        class="navbar-toggler m-2 ml-auto"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>

      <menu-horizontal
        v-if="itensMenu.length"
        :itens="itensMenu"
        :usuario="usuario"
        :logout-callback="logoutCallback"
      />
    </div>
  </nav>
</template>

<script>
export default {
  name: "Topo",
  props: {
    logoURL: {
      type: String,
      default: ""
    },
    sigla: {
      type: String,
      default: ""
    },
    nome: {
      type: String,
      default: ""
    },
    itensMenu: {
      type: Array,
      default: () => []
    },
    usuario: {
      type: Object,
      default: () => {}
    },
    logoutCallback: {
      type: Function,
      default: () => {}
    },
    homeLink: {
      type: String,
      default: "login"
    }
  }
};
</script>